import { StatusKind } from '../../../components/status-pill/status-pill.component';
import { TestStepRunStatus } from '../../../models/test-case.model';

export type TestStepStatus = 'draft' | 'running' | 'passed' | 'failed';

export const TEST_STEP_STATUSES: readonly TestStepStatus[] = ['draft', 'running', 'passed', 'failed'];

export const DEFAULT_TEST_STEP_STATUS: TestStepStatus = 'draft';

const STATUS_TO_PILL_KIND: Record<TestStepStatus, StatusKind> = {
  draft: 'inaktiv',
  running: 'laufend',
  passed: 'aktiv',
  failed: 'fehler',
};

const TO_RUN_STATUS: Record<TestStepStatus, TestStepRunStatus> = {
  draft: 'DRAFT',
  running: 'RUNNING',
  passed: 'PASSED',
  failed: 'FAILED',
};

const FROM_RUN_STATUS: Record<TestStepRunStatus, TestStepStatus> = {
  DRAFT: 'draft',
  RUNNING: 'running',
  PASSED: 'passed',
  FAILED: 'failed',
};

export function pillKindForStatus(status: TestStepStatus): StatusKind {
  return STATUS_TO_PILL_KIND[status];
}

export function toRunStatus(status: TestStepStatus): TestStepRunStatus {
  return TO_RUN_STATUS[status];
}

export function fromRunStatus(status: TestStepRunStatus | null | undefined): TestStepStatus {
  return status ? FROM_RUN_STATUS[status] : DEFAULT_TEST_STEP_STATUS;
}
